import { useParams } from 'react-router-dom';
import { AssignmentRoleMapping } from 'models/Lead';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAdminUsersQuery, useDealByIdQuery, useDealManagementQuery } from 'api';

export const useDetails = () => {
  const { id } = useParams() as { id: string };
  const { data: dealDetails = {}, isLoading: isDealDetailsLoading } = useDealByIdQuery({ id });
  const { data: { management: dealManagement = {} } = {}, isLoading: isDealManagementLoading } = useDealManagementQuery(
    { id }
  );
  const { data: adminUsers = [] } = useAdminUsersQuery();
  const [openAssignmentEditModal, setOpenAssignmentEditModal] = useState(false);
  const [adminUsersMapping, setAdminUsersMapping] = useState({} as Record<string, any>);

  useEffect(() => {
    if (adminUsers.length) {
      const map = adminUsers.reduce((acc: Record<string, any>, item: any) => {
        acc[item.value] = item;
        return acc;
      }, {});
      setAdminUsersMapping(map);
    }
  }, [adminUsers]);

  const onUpdateAssignmentClick = useCallback(() => {
    setOpenAssignmentEditModal(true);
  }, []);

  const onCloseAssignmentEditModal = useCallback(() => {
    setOpenAssignmentEditModal(false);
  }, []);

  const isLoading = isDealDetailsLoading || isDealManagementLoading;
  const isFinalStatus = dealDetails?.isFinalStatus || false;

  const assignmentData = useMemo(() => {
    return [
      { role: AssignmentRoleMapping.purchaseManager, data: dealManagement.purchaseManager || {} },
      {
        role: AssignmentRoleMapping.purchaseManagerAssistant,
        data: dealManagement.purchaseManagerAssistant || {},
      },
      { role: AssignmentRoleMapping.salesManager, data: dealManagement.salesManager || {} },
      { role: AssignmentRoleMapping.salesManagerAssistant, data: dealManagement.salesManagerAssistant || {} },
      { role: AssignmentRoleMapping.postSalesManager, data: dealManagement.postSalesManager || {} },
      {
        role: AssignmentRoleMapping.postSalesManagerAssistant,
        data: dealManagement.postSalesManagerAssistant || {},
      },
    ];
  }, [dealManagement]);

  return {
    onUpdateAssignmentClick,
    dealDetails,
    openAssignmentEditModal,
    onCloseAssignmentEditModal,
    adminUsersMapping,
    assignmentData,
    isLoading,
    isFinalStatus,
  };
};
